import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { UIRouterModule } from '@uirouter/angular';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { MonEllipsisDirective } from './directives/mon-ellipsis/mon-ellipsis.directive';
import { MonFoldableDirective } from './directives/mon-foldable/mon-foldable.directive';

@NgModule({
    imports: [
        CommonModule,
        BreadcrumbModule,
        UIRouterModule,
        BreadcrumbComponent,
        MonEllipsisDirective,
        MonFoldableDirective,
    ],
    exports: [
        BreadcrumbComponent,
        MonEllipsisDirective,
        MonFoldableDirective,
    ],
})
export class SharedModule {}
